import React from 'react'
import Footer from '../components/footerComponent/footer'
import Home from '../components/homeComponent/homeComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function HomePage() {
    return (
        <Layout>
            <Header/>
            <Home/>
            <Footer/>
        </Layout>
    );
};